<template>
    <div v-if="video_data" class="card video-card h-100 d-flex flex-column">
        <div class="ratio ratio-16x9 w-100 position-relative" @click="$emit('play', video_data.id)" role="button">
            <img class="w-100 h-100 object-fit-cover" :src="video_data.thumbnail" :alt="video_data.title"
                loading="lazy" />
            <div class="play-overlay d-flex align-items-center justify-content-center">
                <span class="play-icon"></span>
            </div>
        </div>

        <div class="card-body d-flex flex-column">
            <a class="stretched-link-fix text-decoration-none"
                :href="`https://www.youtube.com/watch?v=${video_data.id}`" target="_blank" rel="noopener">
                <h4 class="card-title clamp-2 mb-2">{{ video_data.title }}</h4>
            </a>

            <span class="text-muted mb-2">{{ (video_data.publishedAt || '').slice(0, 10) }}</span>

            <p class="card-text clamp-3 mb-0">
                {{ video_data.description }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "VideoCard",
    props: ["video_data"],
    data() {
        return {};
    },
    emits: ["play"]
};
</script>

<style lang="scss">
.video-card {
    cursor: default;

    .ratio {
        overflow: hidden;
    }

    img {
        object-fit: cover;
        transition: transform .2s ease-in-out, filter .2s ease-in-out;
    }

    .play-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(transparent, rgba(0, 0, 0, .15));
        transition: background .2s ease-in-out;
    }

    .play-icon {
        width: 62px;
        height: 62px;
        border-radius: 50%;
        background: rgba(0, 0, 0, .55);
        position: relative;
    }

    .play-icon::after {
        content: "";
        position: absolute;
        left: 23px;
        top: 18px;
        border-left: 18px solid #fff;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
    }

    .ratio:hover img {
        transform: scale(1.02);
        filter: brightness(0.95);
    }
}

/* Multi-line clamp helpers */
.clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* Make the link only wrap the title text (so click on the image opens the overlay) */
.stretched-link-fix {
    display: inline-block;
}
</style>